import { OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';

export interface EzForm extends OnDestroy {
  isUnsaved: () => boolean;
}

export function isUnsavedDefault(form: FormGroup): boolean {
  return form?.dirty;
}
